










































import { Component, Prop, Vue } from 'vue-property-decorator'
import { SimpleProjectDto } from '@/models/dtos/simpleProjectDto'
import { EProjectStatus } from '@/models/dtos/enums/eProjectStatus'
import { TemplateService as _templateService } from '@/services/template.service'
import { ProjectMixin } from '@/mixins/projectMixin'
import { mixins } from 'vue-class-component'

@Component
export default class ProjectList extends mixins(ProjectMixin) {
  @Prop({ type: Array, required: true }) projects!: SimpleProjectDto[];

  // Data
  EProjectStatus = EProjectStatus

  // Methods
  private addProjectEntry(project: SimpleProjectDto) {
    this.$root.$emit('show-workbook-entry-modal', null, project.id)
  }

  // Emit
  private start(taskId: string) {
    this.$emit('start', taskId)
  }
}
